import { IonToolbar, IonButtons, IonBackButton, IonTitle } from "@ionic/react";

export const Toolbar = () => {
  return (
    <IonToolbar>
      <IonButtons slot="start">
        <IonBackButton color="light" defaultHref="/app/tic" />
      </IonButtons>
      <IonTitle>Plantillas</IonTitle>
    </IonToolbar>
  );
};
